<template>
  <v-container grid-list-md fluid>
    <v-layout row wrap>
      <v-flex md12>
        <data-table ref="tableGeo" />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import DataTable from "@/views/bitacoras/geolocalizacion/DataTable"; /** *******************************/

export default {
  name: "BitacoraGeolocalizacion"
  , components: {
    DataTable
  }
  , data() {
    return {
      view: {
        title: this.$t("view.bitacoras.geolocalizacion.title")
        , elem: { showForm: true }
      }
    };
  }
  , head: {
    title: function () {
      return {
        inner: this.view.title
        , separator: "|"
        , complement: this.$t("view.commons.system")
      };
    }
  }
  , methods: {
    reload() {
      this.$refs.tableGeo.refreshData();
    }
    , recargarTabla() {
      this.reload();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/bitacoras/geolocalizacion/BitacoraGeolocalizacion.vue